var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"id":"title-bar","app":"","dark":"","color":"#1A237E"}},[_c('v-img',{staticClass:"mx-2",attrs:{"src":require("@/assets/banzai-logo.png"),"max-height":"40","max-width":"40"}}),_c('v-toolbar-title',[_vm._v("BANZAI Web Tools")]),_c('v-spacer')],1),_c('v-main',[_c('MainWindow')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }